import React from "react";
import { ExercisePublishResume, ExerciseStatus } from "service/exercise";
import moment from "moment";

interface BriefInfoProps {
    status: number;
    item: ExercisePublishResume;
}

export default function BriefInfo({ item, status }: BriefInfoProps) {
    return (
        <>
            {item.validityTime && (
                <span>活动时长 {item.validityTime} 分钟</span>
            )}

            {!item.validityTime && <span>活动时长不限</span>}

            {(item.startTime || item.endTime) && (
                <span>
                    &nbsp;|&nbsp;
                    {(status === ExerciseStatus.doing ||
                        status === ExerciseStatus.done) &&
                        item.startTime && (
                            <>
                                开始时间{" "}
                                {moment(item.startTime).format("MM-DD HH:mm")}
                                &nbsp;&nbsp;
                            </>
                        )}
                    {status === ExerciseStatus.done && item.endTime && (
                        <>
                            结束时间{" "}
                            {moment(item.endTime).format("MM-DD HH:mm")}
                        </>
                    )}
                </span>
            )}
        </>
    );
}
